<template>
  <n-scrollable>
    <n-layout>
      <n-column :span="6" class="title">
        <n-text-model color="accent" size="xl" weight="regular">
          {{ $t('bookRideAuthPhone.title') }}
        </n-text-model>
      </n-column>

      <n-text class="span-6 description" preset="body">
        {{ $t('bookRideAuthPhone.description') }}
      </n-text>

      <n-column :span="6">
        <phone-auth @otp-requested="onOTPRequested" @otp-error="onOTPError" />
      </n-column>
    </n-layout>
  </n-scrollable>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import PhoneAuth from '@/components/shared/auth/phoneAuth';

export default {
  name: 'landingBookRideAuthPhone',
  components: {
    PhoneAuth,
  },
  computed: {
    ...mapState('trip', ['bookingTrip']),
  },
  methods: {
    ...mapMutations('app', {
      setLandingPageData: 'SET_LANDING_PAGE_DATA',
    }),
    onOTPError(description) {
      if (!description) {
        this.$error();
        return;
      }

      this.$error({ description });
    },
    onOTPRequested({ phoneNumber, phoneCountryCode, exists }) {
      if (exists) {
        this.resetReferrals();
      } else {
        this.setReferrals();
      }

      this.$router.replace({
        name: 'landing-book-ride.otp',
        query: { phoneCountryCode, phoneNumber, exists },
      });
    },
    setReferrals() {
      this.setLandingPageData({
        referrals: {
          'utm_source': 'instant-booking',
          'utm_medium': 'qr',
          'trip_id': this.bookingTrip?.id,
          'driver_id': this.bookingTrip?.driver.id,
        }
      });
    },
    resetReferrals() {
      this.setLandingPageData({
        referrals: {},
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.title {
  margin-top: 0.5rem;
}

.description {
  margin-bottom: 1rem;
}
</style>